module.exports = __webpack_public_path__ + "pc/img/loginbg2.f5ad59fc.png";